import { render, staticRenderFns } from "./SearchResultsClassic.vue?vue&type=template&id=17e78e87&scoped=true"
import script from "./SearchResultsClassic.vue?vue&type=script&lang=js"
export * from "./SearchResultsClassic.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsClassic.vue?vue&type=style&index=0&id=17e78e87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e78e87",
  null
  
)

export default component.exports